import { render, staticRenderFns } from "./directPkg.vue?vue&type=template&id=3315638c&scoped=true&"
import script from "./directPkg.vue?vue&type=script&lang=js&"
export * from "./directPkg.vue?vue&type=script&lang=js&"
import style0 from "./directPkg.vue?vue&type=style&index=0&id=3315638c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3315638c",
  null
  
)

export default component.exports